import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-490d755b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "study-material-page"
};
const _hoisted_2 = {
  class: "content-panel"
};
const _hoisted_3 = {
  class: "page-header"
};
const _hoisted_4 = {
  class: "page-title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title-icon"
}, "📚", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title-text"
}, "学习资料", -1));
const _hoisted_7 = {
  class: "title-count"
};
const _hoisted_8 = {
  class: "search-wrapper"
};
import { onMounted, ref, watchEffect } from 'vue';
import StudyMaterialList from "@/components/studyMaterial/StudyMaterialList.vue";
import { useRoute, useRouter } from "vue-router";
import { SearchOutlined } from '@ant-design/icons-vue';
import { XiaoniuStudyMaterialControllerService } from "../../generated/services/XiaoniuStudyMaterialControllerService";
export default /*#__PURE__*/_defineComponent({
  __name: 'StudyMaterialView',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const materialList = ref([]);
    const materialListTotal = ref(0);
    // 模拟数据 - 用于测试和API异常时兜底
    const mockMaterials = [
      // {
      //   id: 100001,
      //   name: '2025考研英语高频词汇精选',
      //   coverImage: 'http://ocr.nbdj.cc/test/study-material-default.png',
      //   price: 29.9,
      //   description: '精选5500考研词汇+高频词组，搭配真题例句，助你高效记忆',
      //   viewCount: 3856,
      //   buyCount: 1289,
      //   createTime: '2025-08-15'
      // },
      // {
      //   id: 100002,
      //   name: 'Java面试宝典·大厂真题集',
      //   coverImage: 'http://ocr.nbdj.cc/test/study-material-default.png',
      //   price: 19.9,
      //   description: '收录BAT等大厂最新面试真题，附详细解答与知识点扩展',
      //   viewCount: 5621,
      //   buyCount: 2304,
      //   createTime: '2025-09-02'
      // },
      // {
      //   id: 100003,
      //   name: '软件设计师中级历年真题',
      //   coverImage: 'http://ocr.nbdj.cc/test/study-material-default.png',
      //   price: 0,
      //   description: '2018-2024年软件设计师考试真题，含详细答案解析（免费分享）',
      //   viewCount: 7823,
      //   buyCount: 3456,
      //   createTime: '2025-07-20'
      // },
      // {
      //   id: 100004,
      //   name: 'Python数据分析实战手册',
      //   coverImage: 'http://ocr.nbdj.cc/test/study-material-default.png',
      //   price: 39.9,
      //   description: '从零开始学习Pandas、NumPy、Matplotlib，包含10个真实案例',
      //   viewCount: 2456,
      //   buyCount: 893,
      //   createTime: '2025-08-28'
      // },
      // {
      //   id: 100005,
      //   name: '公务员考试行测速解技巧',
      //   coverImage: 'http://ocr.nbdj.cc/test/study-material-default.png',
      //   price: 25.9,
      //   description: '数量关系、言语理解、逻辑推理三大模块速解技巧合集',
      //   viewCount: 3102,
      //   buyCount: 1245,
      //   createTime: '2025-09-10'
      // },
      // {
      //   id: 100006,
      //   name: '计算机网络学习笔记',
      //   coverImage: 'http://ocr.nbdj.cc/test/study-material-default.png',
      //   price: 0,
      //   description: '基于谢希仁《计算机网络》整理的精华笔记（免费领取）',
      //   viewCount: 9234,
      //   buyCount: 4521,
      //   createTime: '2025-06-12'
      // },
      // {
      //   id: 100007,
      //   name: '前端面试必备·Vue3核心原理',
      //   coverImage: 'http://ocr.nbdj.cc/test/study-material-default.png',
      //   price: 15.9,
      //   description: '深入剖析Vue3响应式原理、diff算法、编译优化',
      //   viewCount: 4321,
      //   buyCount: 1567,
      //   createTime: '2025-09-05'
      // },
      // {
      //   id: 100008,
      //   name: '高数期末复习冲刺包',
      //   coverImage: 'http://ocr.nbdj.cc/test/study-material-default.png',
      //   price: 12.9,
      //   description: '同济版高数上下册重点公式+典型例题+真题汇总',
      //   viewCount: 2890,
      //   buyCount: 1023,
      //   createTime: '2025-09-15'
      // }
    ];
    const initSearchParams = {
      name: "",
      pageNum: 1,
      pageSize: 8
    };
    const searchParams = ref({
      ...initSearchParams
    });
    onMounted(() => {
      getMaterialList(searchParams.value);
    });
    watchEffect(() => {
      searchParams.value = {
        name: route.query.name || '',
        pageNum: parseInt(route.query.pageNum) || 1,
        pageSize: parseInt(route.query.pageSize) || 8
      };
    });
    const getMaterialList = params => {
      XiaoniuStudyMaterialControllerService.listUsingGet20(params).then(res => {
        const rows = res.rows || [];
        if (rows.length === 0) {
          // 接口返回空，使用模拟数据兜底
          console.info('StudyMaterial: 接口无数据，使用模拟数据');
          materialList.value = mockMaterials;
          materialListTotal.value = mockMaterials.length;
        } else {
          materialList.value = rows;
          materialListTotal.value = res.total || rows.length;
        }
      }).catch(err => {
        console.warn('获取资料列表失败，使用模拟数据:', err);
        materialList.value = mockMaterials;
        materialListTotal.value = mockMaterials.length;
      });
    };
    const pageChange = () => {
      getMaterialList(searchParams.value);
      router.push({
        query: {
          ...searchParams.value
        }
      });
    };
    const onSearch = text => {
      searchParams.value = {
        name: text,
        pageNum: 1,
        pageSize: 8
      };
      getMaterialList(searchParams.value);
      router.push({
        query: {
          ...searchParams.value
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_MyPagination = _resolveComponent("MyPagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("span", _hoisted_7, "共 " + _toDisplayString(materialListTotal.value) + " 个", 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_a_input_search, {
        value: searchParams.value.name,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => searchParams.value.name = $event),
        placeholder: "搜索你感兴趣的资料...",
        "enter-button": "",
        size: "large",
        onSearch: onSearch
      }, {
        prefix: _withCtx(() => [_createVNode(_unref(SearchOutlined))]),
        _: 1
      }, 8, ["value"])])]), _createVNode(StudyMaterialList, {
        "material-list": materialList.value
      }, null, 8, ["material-list"]), _createVNode(_component_MyPagination, {
        currentPage: searchParams.value.pageNum,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => searchParams.value.pageNum = $event),
        pageSize: searchParams.value.pageSize,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => searchParams.value.pageSize = $event),
        total: materialListTotal.value,
        onChange: pageChange
      }, null, 8, ["currentPage", "pageSize", "total"])])]);
    };
  }
});